import { render, staticRenderFns } from "./Join1.vue?vue&type=template&id=df74c82c&scoped=true&"
import script from "./Join1.vue?vue&type=script&lang=js&"
export * from "./Join1.vue?vue&type=script&lang=js&"
import style0 from "./Join1.vue?vue&type=style&index=0&id=df74c82c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df74c82c",
  null
  
)

export default component.exports